import React, { FC, memo, useCallback, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { toast } from 'react-toastify'
import { Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { Colors } from '../../../../../../theme'
import { Modal } from '../../../../../../components/Dashboard/Modal'
import { useRest } from '../../../../../../components/Context'
import { IPortfolioData } from '../CurrentPortfolioTableLists'

const useStyles = makeStyles((theme: Theme) => ({
  modalInput: {
    width: 300,
    textAlign: 'right',
  },
  modalItem: {
    marginTop: 25,
  },
  subtitle: {
    color: '#b2b3b5',
    fontWeight: 500,
  },
  subtitleDisable: {
    color: Colors.white,
    opacity: '30%',
  },
  button: {
    paddingLeft: 15,
  },
  table: {
    paddingTop: theme.spacing(3),
  },
  amount: {
    fontSize: 24,
    fontWeight: 'bold',
    color: theme.palette.secondary.main,
  },
}))

interface IEditAsset {
  data: IPortfolioData
  isOpen: boolean
  modalClose: () => void
}

const ClaimYieldPopup: FC<IEditAsset> = ({ isOpen, modalClose, data }) => {
  const formMethods = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    shouldFocusError: true,
  })

  const { handleSubmit } = formMethods

  const classes = useStyles()
  const { rxiosAuth } = useRest()

  const [loading, setLoading] = useState<boolean>(false)

  const onSubmit = useCallback(
    // eslint-disable-next-line
    () => {
      let cleanupFunction = false
      setLoading(true)

      rxiosAuth.post(`staking/claim`, { asset: data.basket }).subscribe(
        // eslint-disable-next-line
        (next: any) => {
          if (!cleanupFunction) setLoading(false)
        },
        (error) => {
          toast.error(error.response.data.message)
          setLoading(false)
        },
        () => {
          toast.success('Yield was successfully claimed')
          formMethods.reset()
          setLoading(false)
          modalClose()
        },
      )
      cleanupFunction = true
    },
    // eslint-disable-next-line
    [rxiosAuth, data],
  )

  return (
    <Modal
      title="Warning!"
      isOpen={isOpen}
      modalClose={modalClose}
      isSubmit
      submitTitle={'Confirm'}
      onSubmit={handleSubmit(onSubmit)}
      isLoading={loading}
    >
      <FormProvider {...formMethods}>
        <Typography>
          Transaction fees are <span className={classes.amount}>3.75</span> USD. Please confirm or cancel?
        </Typography>
      </FormProvider>
    </Modal>
  )
}

export const MemoClaimYieldPopup = memo(ClaimYieldPopup)
